module.exports = __webpack_public_path__ + "img/baa_ultraplatinum.e6e057c0.png";